export const usePlatformAndChatUrlHandler = ({
    userRole,
    streamData,
    selectedTab,
    getEmbedDomain,
    STREAM_ROLES,
    STREAM_PLATFORMS,
  }) => {
    const getAvailablePlatforms = () => {
      const platforms = [];
      if (userRole === STREAM_ROLES.ORGANISER) {
        if (streamData?.organizerYoutubeStream) platforms.push(STREAM_PLATFORMS.YOUTUBE_CAPITALIZED);
        if (streamData?.organizerTwitchStream) platforms.push(STREAM_PLATFORMS.TWITCH_CAPITALIZED);
      } else if (userRole === STREAM_ROLES.CHALLENGER) {
        if (streamData?.challengerYoutubeStream) platforms.push(STREAM_PLATFORMS.YOUTUBE_CAPITALIZED);
        if (streamData?.challengerTwitchStream) platforms.push(STREAM_PLATFORMS.TWITCH_CAPITALIZED);
      }
      return ["KO Chat", ...platforms];
    };
  
    const getLiveChatUrl = () => {
      const embedDomain = getEmbedDomain();
      const platform = selectedTab;
      if (platform === STREAM_PLATFORMS.YOUTUBE_CAPITALIZED) {
        const url = userRole === STREAM_ROLES.ORGANISER
          ? streamData?.organizerYoutubeStream?.liveChatUrl
          : userRole === STREAM_ROLES.CHALLENGER
          ? streamData?.challengerYoutubeStream?.liveChatUrl
          : null;
        return url ? `${url}${embedDomain}` : null;
      } else if (platform === STREAM_PLATFORMS.TWITCH_CAPITALIZED) {
        const url = userRole === STREAM_ROLES.ORGANISER
          ? streamData?.organizerTwitchStream?.liveChatUrl
          : userRole === STREAM_ROLES.CHALLENGER
          ? streamData?.challengerTwitchStream?.liveChatUrl
          : null;
        return url ? `${url}${embedDomain}` : null;
      }
      return null;
    };
  
    return { getAvailablePlatforms, getLiveChatUrl };
  };